/**
 * Estimate calculator pricing model — customer-provided rates.
 * All rates are per SQUARE FOOT unless the `unit` is 'linft' (linear feet)
 * or 'ea' (per pane / per unit).
 */
export const CALC_SERVICES = [
  // ---- House / Soft Wash ----
  { key: "housewash_vinyl",  label: "House Wash — Vinyl / Aluminum siding", unit: "sqft", unitLabel: "sq ft of siding", rate: 0.30, minimum: 279, hint: "Ranch ~1500 sq ft; 2-story ~2500 sq ft." },
  { key: "housewash_brick",  label: "House Wash — Brick",                   unit: "sqft", unitLabel: "sq ft of siding", rate: 0.25, minimum: 279, hint: "Ranch ~1500 sq ft; 2-story ~2500 sq ft." },
  { key: "housewash_paint",  label: "House Wash — Painted / Hardie board",  unit: "sqft", unitLabel: "sq ft of siding", rate: 0.35, minimum: 279, hint: "Ranch ~1500 sq ft; 2-story ~2500 sq ft." },
  { key: "housewash_stucco", label: "House Wash — Stucco",                  unit: "sqft", unitLabel: "sq ft of siding", rate: 0.35, minimum: 279, hint: "Ranch ~1500 sq ft; 2-story ~2500 sq ft." },

  // ---- Concrete / Flatwork ----
  { key: "driveway",   label: "Driveway",                    unit: "sqft", unitLabel: "sq ft", rate: 0.25, minimum: 179, hint: "2-car driveway ≈ 600 sq ft." },
  { key: "sidewalk",   label: "Sidewalk / Walkway",          unit: "sqft", unitLabel: "sq ft", rate: 0.25, minimum: 99,  hint: "3-ft-wide walkway ≈ 45 sq ft per 15 linear ft." },
  { key: "pool_deck",  label: "Pool Deck",                   unit: "sqft", unitLabel: "sq ft", rate: 0.40, minimum: 199, hint: "Standard rectangular pool deck ~400–800 sq ft." },
  { key: "paver",      label: "Paver Patio / Walkway",       unit: "sqft", unitLabel: "sq ft", rate: 0.45, minimum: 199, hint: "Joint-safe technique so sand stays put." },

  // ---- Decks ----
  { key: "deck_comp",  label: "Deck — Composition / Composite", unit: "sqft", unitLabel: "sq ft", rate: 0.30, minimum: 199, hint: "Low-pressure treatment safe for composite." },
  { key: "deck_wood",  label: "Deck — Wood",                    unit: "sqft", unitLabel: "sq ft", rate: 0.40, minimum: 199, hint: "Cedar, pine, or treated lumber." },

  // ---- Fences ----
  { key: "fence_vinyl", label: "Fence — Vinyl",  unit: "linft", unitLabel: "linear ft", rate: 1.75, minimum: 219, hint: "Both sides where accessible." },
  { key: "fence_wood",  label: "Fence — Wood",   unit: "linft", unitLabel: "linear ft", rate: 2.25, minimum: 219, hint: "Both sides where accessible." },

  // ---- Roof ----
  { key: "roof_asphalt", label: "Roof Wash — Asphalt shingles", unit: "sqft", unitLabel: "roof area sq ft", rate: 0.50, minimum: 499, hint: "Approx. home footprint × 1.3 for pitched roofs." },
  { key: "roof_metal",   label: "Roof Wash — Metal",            unit: "sqft", unitLabel: "roof area sq ft", rate: 0.40, minimum: 499, hint: "Approx. home footprint × 1.3 for pitched roofs." },

  // ---- Solar ----
  { key: "solar",   label: "Solar Panels", unit: "ea",  unitLabel: "panels", rate: 15,   minimum: 149, hint: "Count each panel — typical residential array 12–24 panels." },

  // ---- Gutters ----
  { key: "gutter_clean",     label: "Gutter Cleaning (debris + downspout flush)", unit: "linft", unitLabel: "linear ft of gutter", rate: 1.25, minimum: 139, hint: "One-story ranch ≈ 150 linear ft." },
  { key: "gutter_brighten",  label: "Gutter Brightening (exterior face)",         unit: "linft", unitLabel: "linear ft of gutter", rate: 2.00, minimum: 149, hint: "Removes black tiger-stripe oxidation." },
];

/**
 * Compute a range estimate.
 * Base = sum(qty * rate) with per-service minimum enforced.
 * Low = base × 0.95, High = base × 1.15 to reflect access / condition variance.
 */
export function computeEstimate(entries) {
  let base = 0;
  const lineItems = [];
  for (const e of entries) {
    if (!e.key || !e.quantity || e.quantity <= 0) continue;
    const svc = CALC_SERVICES.find((s) => s.key === e.key);
    if (!svc) continue;
    const raw = e.quantity * svc.rate;
    const subtotal = Math.max(raw, svc.minimum);
    base += subtotal;
    lineItems.push({
      service: svc.label,
      quantity: e.quantity,
      unit: svc.unit,
      subtotal,
    });
  }
  const low = Math.round((base * 95) / 100);
  const high = Math.round((base * 115) / 100);
  return { low, high, base: Math.round(base), lineItems };
}
